// extracted by mini-css-extract-plugin
export default {"countdown":"j0-z","srOnly":"k0-z"};